import { render, staticRenderFns } from "./StatementItemDetailsTableItem.vue?vue&type=template&id=5ff182d2&functional=true&"
import script from "./StatementItemDetailsTableItem.vue?vue&type=script&lang=ts&"
export * from "./StatementItemDetailsTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports